import { TransactionError } from '@thirdweb-dev/sdk'
import { ZodError } from 'zod'
import { errors } from '~/constants/error'
import { ApplicationError } from '~/domain/ApplicationError'

const makeContractError = (exception: TransactionError, nativeCurrencySymbol?: string): ApplicationError => {
  for (const code of Object.keys(errors)) {
    if (exception.message.includes(code)) {
      const error = errors[code]

      if (error.code === 'INSUFFICIENT_FUNDS') {
        if (nativeCurrencySymbol)
          error.message = error.message.replace('{{currency}}', nativeCurrencySymbol)
        else {
          error.message = error.message.replace('{{currency}}', 'native currency')
        }
      }

      return error
    }  
  }

  console.error(exception)

  return errors['UNKNOWN_TX_ERROR']
}

const makeGenericError = (exception: Error): ApplicationError => {
  return {
    code: 'GENERIC',
    message: exception.message,
  }
}

const makeValidationError = (exception: ZodError): ApplicationError => {
  const message = exception.errors.length === 0 ? 'Validation error' : exception.errors[0].message

  return {
    code: 'VALIDATION',
    message,
  }
}

const makeUnknownError = (exception: unknown): ApplicationError => {
  console.error(exception)

  return {
    code: 'UNKNOWN',
    message: 'Unexpected error, please report if it persists',
  }
}

export const parseTransactionError = (exception: unknown, nativeCurrencySymbol?: string): ApplicationError => {
  if (exception instanceof TransactionError) {
    return makeContractError(exception, nativeCurrencySymbol)
  }

  if (exception instanceof ZodError) {
    return makeValidationError(exception)
  }

  if (exception instanceof Error) {
    return makeGenericError(exception)
  }

  return makeUnknownError(exception)
}

export class ApiError {
  constructor (
    public readonly requestMethod: string,
    public readonly requestPath: string,
    public readonly responseStatus: number,
    public readonly responseBody?: string
  ) { }
}
